// Content for the Compteurs d'eau ATNA final call to action.
export type Bi = { fr: string; en: string }

export const waterFinalCta = {
  eyebrow: { fr: 'Compteurs d’eau ATNA', en: 'ATNA Smart Water' },
  navy: { fr: 'Transformez vos données de consommation d’eau', en: 'Turn your water data' },
  indigo: { fr: 'en actions concrètes.', en: 'into concrete action.' },
  body: {
    fr: 'Voyez comment BCITI | ATNA peut connecter vos compteurs, vos propriétés et vos usagers pour mieux comprendre la consommation, prévenir les anomalies et agir au bon moment.',
    en: 'See how BCITI | ATNA can connect your meters, your properties and your users to better understand consumption, prevent anomalies and act at the right time.',
  },
  primary: { fr: 'Demander une démo', en: 'Request a demo' },
  secondary: { fr: 'Parler à notre équipe', en: 'Talk to our team' },
}

export type WaterCapabilityKey = 'sensors' | 'api' | 'photo' | 'identity' | 'insights' | 'notifications' | 'requests' | 'payments'

export const waterFinalCapabilities: { key: WaterCapabilityKey; label: Bi }[] = [
  { key: 'sensors', label: { fr: 'Capteurs', en: 'Sensors' } },
  { key: 'api', label: { fr: 'API', en: 'API' } },
  { key: 'photo', label: { fr: 'Photo du compteur', en: 'Meter photo' } },
  { key: 'identity', label: { fr: 'Identité', en: 'Identity' } },
  { key: 'insights', label: { fr: 'Analyses ATNA', en: 'ATNA insights' } },
  { key: 'notifications', label: { fr: 'Notifications', en: 'Notifications' } },
  { key: 'requests', label: { fr: 'Requêtes', en: 'Requests' } },
  { key: 'payments', label: { fr: 'Paiements', en: 'Payments' } },
]
